(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trade-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-trade-sticky]');
    var form = document.getElementById('trade-form');
    if (!bar || !form) return;

    var formVisible = false;
    var keyboardOpen = false;
    var formFocused = false;

    function sync() {
      var hide = formVisible || keyboardOpen || formFocused;
      bar.hidden = hide;
      document.documentElement.classList.toggle('pp-trade-sticky-active', !hide);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          formVisible = entry.isIntersecting;
          sync();
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      observer.observe(form);
    }

    form.addEventListener('focusin', function () {
      formFocused = true;
      sync();
    });
    form.addEventListener('focusout', function () {
      setTimeout(function () {
        formFocused = form.contains(document.activeElement);
        sync();
      }, 0);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        keyboardOpen = (window.innerHeight - window.visualViewport.height) > 120;
        sync();
      });
    }

    sync();
  })();

  } catch(e) { console.error(e); }
})();
})();
